module.exports = __webpack_public_path__ + "img/ic_normal.eb71c7e3.png";